/* tslint:disable */
/* eslint-disable */
/**
 * AgentAssistService
 * Agent Assist API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AnalyticsImportAggrSectionScores } from './AnalyticsImportAggrSectionScores';
import {
    AnalyticsImportAggrSectionScoresFromJSON,
    AnalyticsImportAggrSectionScoresFromJSONTyped,
    AnalyticsImportAggrSectionScoresToJSON,
} from './AnalyticsImportAggrSectionScores';

/**
 * Extends outputs for "list" type operations to return pagination details
 * @export
 * @interface GetAnalyticsAggregationSectionScoreResponseContent
 */
export interface GetAnalyticsAggregationSectionScoreResponseContent {
    /**
     * Pass this in the next request for another page of results
     * @type {string}
     * @memberof GetAnalyticsAggregationSectionScoreResponseContent
     */
    nextToken?: string;
    /**
     * Map of QAAnalytics in JSON format
     * @type {Array<AnalyticsImportAggrSectionScores>}
     * @memberof GetAnalyticsAggregationSectionScoreResponseContent
     */
    analytics: Array<AnalyticsImportAggrSectionScores>;
}


/**
 * Check if a given object implements the GetAnalyticsAggregationSectionScoreResponseContent interface.
 */
export function instanceOfGetAnalyticsAggregationSectionScoreResponseContent(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "analytics" in value;

    return isInstance;
}

export function GetAnalyticsAggregationSectionScoreResponseContentFromJSON(json: any): GetAnalyticsAggregationSectionScoreResponseContent {
    return GetAnalyticsAggregationSectionScoreResponseContentFromJSONTyped(json, false);
}

export function GetAnalyticsAggregationSectionScoreResponseContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAnalyticsAggregationSectionScoreResponseContent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'nextToken': !exists(json, 'nextToken') ? undefined : json['nextToken'],
        'analytics': ((json['analytics'] as Array<any>).map(AnalyticsImportAggrSectionScoresFromJSON)),
    };
}

export function GetAnalyticsAggregationSectionScoreResponseContentToJSON(value?: GetAnalyticsAggregationSectionScoreResponseContent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'nextToken': value.nextToken,
        'analytics': ((value.analytics as Array<any>).map(AnalyticsImportAggrSectionScoresToJSON)),
    };
}

